import {
  AssessmentIcon,
  CloseIcon,
  HamburgerMenuIcon,
  LogoutIcon,
  OverviewIcon,
  ReportIcon,
  SettingsIcon,
  SubscriptionIcon,
  logoWithText,
  LogoWithTextWhite,
  PrecisionLogoMain,
  PrecisionLogo,
  SupportIcon,
  ConvertShapeIcon,
  MenuBoardIcon,
  PeopleIconII,
  ArrowDownIcon,
  WalletMoneyIcon,
  CubeIcon,
  SliderHorizontalIcon,
  LogoWithText,
  ChevronRightIcon,
} from "assets";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";
import { Routes } from "router";
import { tabs } from "..";
import { useRef, useState } from "react";
import { useAppSelector } from "state/hooks";
import { Signout } from "pages";
import { useClickOutside, useMobile } from "hooks";
import { ShareModal } from "components/modal-variants/share-modal";
import { CreditIndicator } from "../../../components/credit-indicator";
import { CreditStatusModal } from "pages/pricing-v2/components/credit-status-modal";
import { BuyAdditionalCreditModal } from "pages/pricing-v2/components/buy-additional-credit-modal";
import { useCredits } from "hooks/useCredits";

interface SidebarProps {
  active: tabs;
}

const SideBar: React.FC<SidebarProps> = ({ active }) => {
  const navref = useRef<HTMLDivElement>(null);
  const mobileWidth = 900;
  const [mobile, setMobile] = useState(
    window.innerWidth <= mobileWidth ? true : false
  );
  const { isMobile: isTablet } = useMobile({ size: 1024 });
  const [showNav, setShowNav] = useState(false);
  const [logout, setLogout] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const screenSizeUpdate = () => {
    if (window.innerWidth <= mobileWidth) {
      setMobile(true);
    } else if (window.innerWidth > mobileWidth) {
      setMobile(false);
      setShowNav(false);
    }
  };

  window.addEventListener("resize", screenSizeUpdate);
  const Navtabs: { label: string; key: string; Icon: React.FC; path: string; section: string; dropdown?: { label: string; key: string; path: string }[] }[] = [
    {
      label: "Hiring Assistant",
      key: "assessment",
      Icon: CubeIcon,
      path: Routes.publishAssessment,
      section: "main",
    },
    {
      label: "Manage Jobs",
      key: "jobs",
      Icon: ConvertShapeIcon,
      path: Routes.manageJobs,
      section: "main",
    },
    // {
    //   label: "Test Library",
    //   key: "library",
    //   Icon: MenuBoardIcon,
    //   path: "",
    //   section: "main",
    //   dropdown: [
    //     { label: "Test 1", key: "test", path: "#" },
    //   ],
    // },
    // {
    //   label: "Talent Bank",
    //   key: "bank",
    //   Icon: PeopleIconII,
    //   path: "",
    //   section: "main",
    //   dropdown: [
    //     { label: "Test 1", key: "test", path: "#" },
    //   ],
    // },
    // {
    //   label: "Interview Center",
    //   key: "interview",
    //   Icon: SliderHorizontalIcon,
    //   path: "",
    //   section: "main",
    // },
    {
      label: "Credits & Billing",
      key: "pricing",
      Icon: WalletMoneyIcon,
      path: Routes.creditsBilling,
      section: "main",
    },
    {
      label: "Settings",
      key: "settings",
      Icon: SettingsIcon,
      path: Routes.settings,
      section: "bottom",
    },
    // {
    //   label: "Support and Knowledge base",
    //   key: "support",
    //   Icon: SupportIcon,
    //   path: "",
    //   section: "bottom",
    // },
    {
      label: "Logout",
      key: "logout",
      Icon: LogoutIcon,
      path: "",
      section: "bottom",
    },
  ];

  useClickOutside(navref, () => setShowNav(false));
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showCreditStatusModal, setShowCreditStatusModal] = useState(false);
  const [showBuyCreditModal, setShowBuyCreditModal] = useState(false);

  const { balance } = useCredits();

  const handleCreditIndicatorClick = () => {
    setShowCreditStatusModal(true);
  };

  const handleLogout = () => {
    mobile && setShowNav(false);
    setLogout(true);
  };
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  }
  const user = useAppSelector((state) => state.user);
  const { companyLogo, firstName, lastName } = user;
  const profileDropdownRef = useRef<HTMLDivElement>(null);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  useClickOutside(profileDropdownRef, () => setShowProfileDropdown(false));
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();

  return (
    <>
      <ShareModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <Signout show={logout} close={() => setLogout(false)} />
      <CreditStatusModal
        isOpen={showCreditStatusModal}
        onClose={() => setShowCreditStatusModal(false)}
        onTopupCredit={() => {
          setShowCreditStatusModal(false);
          setShowBuyCreditModal(true);
        }}
      />
      <BuyAdditionalCreditModal
        isOpen={showBuyCreditModal}
        onClose={() => setShowBuyCreditModal(false)}
        currentBalance={balance}
      />
      <aside
        ref={navref}
        style={{ zIndex: mobile && showNav ? "5000000000" : "500" }}
        className={`${styles.sidebar} ${showNav ? styles.openMenu + " !shadow-lg" : ""}`}
      >
        <div className={styles.logoContainer}>
          <Link to={Routes.home}>
            <PrecisionLogoMain className={styles.precisionLogo} />
          </Link>
        </div>
        <div className="flex items-center justify-between w-full pr-6">
          <div className={styles.logoSec}>
            <Link to={Routes.home}>
              {isTablet ? <img className={styles.logo} src={logoWithText} alt="logo with text" /> : <LogoWithText />}
            </Link>
            {!showNav && (
              <HamburgerMenuIcon onClick={() => setShowNav(true)} role="button" className={styles.hamburger} />
            )}
          </div>

        </div>


        <div className={`${styles.rightIcons} lg:hidden flex`}>
          <CreditIndicator size={32} strokeWidth={4} className="mr-2" onClick={handleCreditIndicatorClick} />
          <div className="relative" ref={profileDropdownRef}>
            <div
              className="flex items-center gap-1 cursor-pointer"
              onClick={() => setShowProfileDropdown(!showProfileDropdown)}
            >
              <div className="w-8 h-8 rounded-full overflow-hidden bg-white border border-gray-300 flex items-center justify-center">
                {companyLogo ? (
                  <img src={companyLogo} alt="User Avatar" className="w-full h-full object-contain" />
                ) : (
                  <span className="text-[#012169] font-semibold text-xs select-none">{initials}</span>
                )}
              </div>
              <ChevronRightIcon className={`${styles.chevron} transition-transform ${showProfileDropdown ? 'rotate-90' : ''}`} />
            </div>
            {showProfileDropdown && (
              <div className="fixed right-4 top-16 bg-white rounded-xl shadow-lg border border-gray-100 py-2 min-w-[160px] z-[6000000000]">
                <Link
                  to={Routes.settings}
                  className="block px-4 py-2.5 text-sm text-[#1D2939] hover:bg-gray-50 transition-colors !text-[#1D2939]"
                  onClick={() => { setShowProfileDropdown(false); setShowNav(false); }}
                >
                  View Profile
                </Link>
                <button
                  className="w-full text-left px-4 py-2.5 text-sm text-[#1D2939] hover:bg-gray-50 transition-colors"
                  onClick={() => { setShowProfileDropdown(false); setShowNav(false); handleLogout(); }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
        <nav className={styles.nav}>
          {Navtabs.filter((tab) => tab.section === "main").map(
            ({ key, label, path, Icon, dropdown }, idx) => (
              <div
                key={idx}
                className={`${styles.dropdown} ${dropdown && dropdownOpen ? styles.open : ""
                  }`}
              >

                {dropdown ? (
                  <div
                    className={`${styles.dropdownToggle} ${dropdownOpen ? styles.open : ""
                      }`}
                    onClick={toggleDropdown}
                  >
                    <Icon />
                    {label}
                    <ArrowDownIcon className={styles.dropdownIcon} />
                  </div>
                ) : (
                  <Link
                    to={path}
                    className={
                      active === key
                        ? styles.active
                        : ""
                    }
                    {...(key === 'assessment' ? { 'data-tour-id': 'tour-nav-hiring-assistant' } : {})}
                    {...(key === 'jobs' ? { 'data-tour-id': 'tour-nav-manage-jobs' } : {})}
                    onClick={() => {
                      setShowNav(false);
                      localStorage.removeItem("assessmentId");
                    }}
                  >
                    <Icon /> {label}
                  </Link>
                )}
                {/* CHANGE: Render dropdown items for Test Library */}
                {dropdown && (
                  <div
                    className={`${styles.dropdownMenu} ${dropdownOpen ? styles.open : ""
                      }`}
                  >
                    {dropdown.map((item, subIdx) => (
                      <Link
                        key={subIdx}
                        to={item.path}
                        className={
                          active === item.key
                            ? styles.active
                            : ""
                        }
                        onClick={() => {
                          setShowNav(false);
                          setDropdownOpen(false);
                        }}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            )
          )}
        </nav>
        <div className={`${styles.nav} ${styles.bottomNav}`}>
          {Navtabs.filter((tab) => tab.section === "bottom").map(
            ({ key, label, path, Icon }, idx) => (
              <Link
                key={idx}
                to={path}
                className={
                  active === key
                    ? styles.active
                    : key === 'logout'
                      ? styles.logout
                      : ''
                }
                onClick={() => {
                  setShowNav(false);
                  if (key === 'logout') {
                    handleLogout();
                  }
                }}
              >
                <Icon /> {label}
              </Link>
            )
          )}
        </div>
      </aside>
    </>
  );
};

export { SideBar };
